import React, { useRef, useState } from "react";
import { addPost } from "../../services/postServices";

const AddNewPost = () => {
  const [postData, setPostData] = useState({
    title: "",
    content: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [images, setImages] = useState([]);
  const [statusAction, setStatusAction] = useState("publish");
  const [categoryAction, setCategoryAction] = useState("painting");

  const handleFileChange = (event) => {
    const fileArray = Array.from(event.target.files);
    setImages(fileArray);
  };

  const fileInputRef = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const action = e.nativeEvent.submitter.value;

      setStatusAction(action);
      const formData = new FormData();
      formData.append("title", postData.title);
      formData.append("content", postData.content);
      formData.append("status", action === "publish");
      formData.append("category", categoryAction === "painting");

      images.forEach((image) => {
        formData.append("images", image);
      });

      await addPost(formData);

      setIsSubmitted(true);

      setTimeout(() => {
        setIsSubmitted(false);
      }, 5000);

      setPostData({ title: "", content: "" });
      setImages([]);
      setCategoryAction("");
      fileInputRef.current.value = "";
    } catch (err) {
      console.error("Upload Failed: ", err);
      setIsSubmitted(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="container my-5">
      <div className="card">
        <div className="card-header">
          <h3>Add New Post</h3>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="postTitle" className="form-label">
                Title
              </label>
              <input
                type="text"
                className="form-control"
                value={postData.title}
                onChange={(e) =>
                  setPostData({ ...postData, title: e.target.value })
                }
                id="postTitle"
                placeholder="Add the title here.."
                required
              />
            </div>
            <div>
              <label htmlFor="postImages" className="form-label">
                Upload Images
              </label>
              <input
                type="file"
                id="postImages"
                name="images"
                className="form-control"
                accept="image/*"
                multiple
                onChange={handleFileChange}
                ref={fileInputRef}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="postContent" className="form-label">
                Content
              </label>
              <textarea
                value={postData.content}
                type="text"
                id="postContent"
                rows="10"
                className="form-control"
                placeholder="Add the content here.."
                onChange={(e) =>
                  setPostData({ ...postData, content: e.target.value })
                }
              />
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="postCategory" className="form-label">
                Category
              </label>
              <select
                className="form-select"
                id="postCategory"
                value={postData.category}
                onChange={(e) => setCategoryAction(e.target.value)}
              >
                <option value="">.....</option>
                <option value="painting">Paiting</option>
                <option value="tailing">Tailing</option>
              </select>
            </div>
            {isSubmitted && (
              <div
                className={`alert ${
                  statusAction === "publish" ? "alert-success" : "alert-info"
                } mt-3`}
                role="alert"
              >
                ✅{" "}
                {statusAction === "publish" ? "Post published" : "Draft saved"}{" "}
                Post Added Successfully!
              </div>
            )}
            <div className="text-end">
              <div className="d-flex justify-content-end gap-2">
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={isLoading}
                  value="publish"
                >
                  {isLoading ? "Publishing..." : "Publish Post"}
                </button>
                <button
                  type="submit"
                  className="btn btn-secondary"
                  disabled={isLoading}
                  value="draft"
                >
                  {isLoading ? "Saving..." : "Save Draft"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default AddNewPost;
